import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  FiHome, 
  FiSettings, 
  FiBarChart2, 
  FiUsers, 
  FiLogOut, 
  FiMenu,
  FiBell,
  FiMapPin,
  FiMessageSquare,
  FiHelpCircle,
  FiSearch,
  FiNavigation,
  FiGlobe,
} from 'react-icons/fi';
import logo from '../../components/assets/logos/logo2.PNG';
import { logout } from '../redux/Slices/authSlice';
import SessionExpiryWarning from '../../components/SessionExpiryWarning';

// FeatureCard component - make it use its own translation hook
const FeatureCard = ({ title, icon: Icon, description, onClick }) => {
  const { t } = useTranslation();
  
  return (
    <div className="feature-card" onClick={onClick}>
      <div className="feature-card__content">
        <div className="feature-card__icon-wrapper">
          <Icon className="feature-card__icon" />
        </div>
        <div className="feature-card__title">{t(title) || title}</div>
        {/* <div className="feature-card__description">{description}</div> */}
      </div>
    </div>
  );
};

const FeaturesSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  };

  const features = [
    {
      id: 1,
      titleKey: 'busFinderPanel',
      icon: FiSearch,
      description: t('busFinderDescription', 'Find buses and manage bus schedules'),
      color: 'rgba(141, 240, 255, 0.7)',
      path: '/busfinderpanel',
    },
    {
      id: 2,
      titleKey: 'routeFinderPanel',
      icon: FiNavigation,
      description: t('routeFinderDescription', 'Find and manage bus routes'),
      color: 'rgba(141, 240, 255, 0.7)',
      path: '/route-finder-panel',
    },
    // {
    //   id: 3,
    //   titleKey: 'noticeBoardPanel',
    //   icon: FiMessageSquare,
    //   description: t('noticeBoardDescription', 'Post and view important notices'),
    //   color: 'rgba(141, 240, 255, 0.7)',
    //   path: '/notices',
    // },
    // {
    //   id: 4,
    //   titleKey: 'userGuidePanel',
    //   icon: FiHelpCircle,
    //   description: t('userGuideDescription', 'User manual and instructions'),
    //   color: 'rgba(141, 240, 255, 0.7)',
    //   path: '/guide',
    // },
    // {
    //   id: 5,
    //   titleKey: 'settingsPanel',
    //   icon: FiSettings,
    //   description: t('settingsDescription', 'System and user settings'),
    //   color: 'rgba(141, 240, 255, 0.7)',
    //   path: '/settings',
    // },
    {
      id: 6,
      titleKey: 'logout',
      icon: FiLogOut,
      description: t('logoutDescription', 'Sign out from the system'),
      color: 'rgba(141, 240, 255, 0.7)',
      action: handleLogout,
    },
  ];

  const handleFeatureClick = (feature) => {
    if (feature.action) {
      feature.action();
    } else if (feature.path) {
      navigate(feature.path);
    }
  };

  return (
    <div className="features-section">
      <div className="features-section__grid">
        {features.map((feature) => (
          <FeatureCard
            key={feature.id}
            title={feature.titleKey}
            icon={feature.icon}
            description={feature.description}
            onClick={() => handleFeatureClick(feature)}
          />
        ))}
      </div>
    </div>
  );
};

const Navbar = () => {
  const { user } = useSelector((state) => state.auth); 
  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  
  const userName = user.userName || user.role || t('guestUser', 'Guest User');
  const userRole = user.role ? 
    user.role.charAt(0).toUpperCase() + user.role.slice(1) : 
    t('unknownRole', 'Unknown Role');
  const userStatus = user.email; 
  const isOnline = !!user.email;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setShowLanguageDropdown(false);
  };

  return (
    <header className="navbar">
      <div className="navbar__left">
        <img 
          src={logo} 
          alt={t('logoAlt', 'Rajdoot Logo')}
          style={{
            width: 150,
            height: 70,
            display: 'block',
          }}
        />
      </div>

      <div className="navbar__right">
        {/* Language Switcher */}
        {/* <div className="language-switcher-container" style={{ position: 'relative' }}>
          <button 
            className="navbar__icon-frame language-button"
            onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              padding: '8px',
              borderRadius: '4px',
              transition: 'background-color 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <FiGlobe size={24} className="navbar__icon" />
            <span style={{ fontSize: '14px', fontWeight: '500' }}>
              {i18n.language === 'en' ? 'EN' : 'HI'}
            </span>
          </button>
          
          {showLanguageDropdown && (
            <div 
              className="language-dropdown"
              style={{
                position: 'absolute',
                top: '100%',
                right: 0,
                backgroundColor: 'white',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                borderRadius: '4px',
                padding: '8px',
                minWidth: '100px',
                zIndex: 1000
              }}
            >
              <button 
                onClick={() => changeLanguage('en')}
                style={{
                  width: '100%',
                  padding: '8px',
                  textAlign: 'left',
                  background: i18n.language === 'en' ? '#f0f0f0' : 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  borderRadius: '3px',
                  marginBottom: '4px'
                }}
              >
                English
              </button>
              <button 
                onClick={() => changeLanguage('hi')}
                style={{
                  width: '100%',
                  padding: '8px',
                  textAlign: 'left',
                  background: i18n.language === 'hi' ? '#f0f0f0' : 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  borderRadius: '3px'
                }}
              >
                हिन्दी
              </button>
            </div>
          )}
        </div> */}

       

        <div className="navbar__user-profile">
          <div className="navbar__user-avatar">
            <span style={{alignContent:'center'}}>
              {userName.split(' ').map(n => n[0]).join('')}
            </span>
          </div>

          <div className="navbar__user-info">
            <div className="navbar__user-name-role">
              <p className="navbar__user-role">{userRole}</p> 
            </div>
            
            <div className="navbar__user-status">
              {isOnline && <span className="navbar__status-dot"></span>}
              <span className="navbar__status-text">{userStatus}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const Sidebar = ({ isCollapsed, toggleCollapse }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const { user } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  
  const menuItems = [
    { id: 1, icon: FiHome, label: t('dashboard', 'Dashboard'), path: '/dashboard' },
    { id: 2, icon: FiSearch, label: t('busFinder', 'Bus Finder'), path: '/busfinderpanel' },
    { id: 3, icon: FiNavigation, label: t('routeFinder', 'Route Finder'), path: '/route-finder-panel' },
    // { id: 4, icon: FiMessageSquare, label: t('notices', 'Notices'), path: '/notices' },
    // { id: 5, icon: FiHelpCircle, label: t('guide', 'Guide'), path: '/guide' },
    // { id: 6, icon: FiSettings, label: t('settings', 'Settings'), path: '/settings' },
  ];

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  };

  const handleMenuItemClick = (item) => {
    if (item.path) {
      navigate(item.path);
    }
  };

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar__header">
        <button className="sidebar__toggle" onClick={toggleCollapse}>
          <FiMenu size={24} />
        </button>
        {!isCollapsed && <h3 className="sidebar__logo">{t('mainMenu', 'Main Menu')}</h3>}
      </div>

      <nav className="sidebar__menu">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className={`sidebar__item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => handleMenuItemClick(item)}
            style={{ cursor: 'pointer' }}
          >
            <item.icon size={20} className="sidebar__icon" />
            {!isCollapsed && <span className="sidebar__label">{item.label}</span>}
          </div>
        ))}
      </nav>

      <div className="sidebar__footer">
        
        
        <div className="sidebar__item logout" onClick={handleLogout}>
          <FiLogOut size={20} className="sidebar__icon" />
          {!isCollapsed && <span className="sidebar__label">{t('logout', 'Logout')}</span>}
        </div>
      </div>
    </div>
  );
};

const DashBoard = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const { t } = useTranslation(); // Initialize translation hook FIRST
  
  // Now you can use t() function

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="dashboard-app-container"> 
      <Navbar />
      <SessionExpiryWarning />
      <div className={`dashboard-content-wrapper ${isCollapsed ? 'collapsed' : ''}`}>
        <Sidebar isCollapsed={isCollapsed} toggleCollapse={toggleCollapse} />
        <div className="dashboard__main">
          <div className="dashboard__content">
            {/* Optional: Welcome Message
            <div className="dashboard__welcome">
              <h1>{t('welcomeBack', 'Welcome back,')} {userName}!</h1>
              <p>{t('dashboardDescription', 'Manage your bus transportation system efficiently')}</p>
            </div> */}
            
            <FeaturesSection />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoard;